import React, { Component } from 'react';
import './SearchWordGame.css'; // Adjust the file path as needed
import Page from '../Page';

class SearchWordGame extends Page {
   constructor(props) {
      super(props);
      const first_states = this.beforeRender(props)
      this.state = {
      // grid: [
      //   ['W', 'O', 'R', 'D', 'S'],
      //   ['E', 'A', 'A', 'R', 'T'],
      //   ['H', 'N', 'I', 'E', 'Y'],
      //   ['S', 'T', 'L', 'A', 'H'],
      //   ['C', 'E', 'S', 'R', 'H'],
      // ],
      // grid:['W', 'O', 'R', 'D', 'S'],
      words: ['jogjakarta', 'HEART', 'SLAY', 'CHEST'],
      selectedLetters: [],
      selectedWord:"",
      isCorrect:false,
      isAnswer:false,
      ...first_states
      };
   }

   beforeRender(props){
      const answer_split = props.answer.split('')
      const make_arr_obj = []
      for(let i in answer_split){
         make_arr_obj.push(answer_split[i])
      }
      const scramble = this.shuffle(make_arr_obj)
      const question = props.question
      console.log('cek scramble',scramble);
      return {
         grid: scramble,
         question: question
      }
   }

   shuffle(array){
      let currentIndex = array.length  
      let randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex > 0) {

      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
         array[randomIndex], array[currentIndex]];
      }

      return array;
   }   

   handleClick = (col) => {
      const { selectedLetters } = this.state;
      let newSelectedLetters = [...selectedLetters];
   
      // Check if the column is already selected
      const selectedIndex = newSelectedLetters.findIndex(coord => coord.col === col);
   
      if (selectedIndex === -1) {
      newSelectedLetters.push({ col });
      } else {
      newSelectedLetters.splice(selectedIndex, 1);
      }
   
      const selectedWord = newSelectedLetters.map(coord => this.state.grid[coord.col]).join('');
   
      this.setState({ selectedLetters: newSelectedLetters, selectedWord });
      // this.setState({ selectedLetters: newSelectedLetters, selectedWord }, () => {
      //   this.checkWord();
      // });
   };
   

   checkWord = () => {
      const { grid, selectedLetters, words } = this.state;
      const selectedWord = selectedLetters.map((coord) =>grid[coord.col]).join('');
      this.setState({selectedWord})
      this.setState({isAnswer: true})
      if (words.includes(selectedWord)) {
         // this.setState({ selectedLetters: [] });
         this.setState({isCorrect: true})
      }else{
         this.setState({isCorrect: false})
      }
   };

   renderGrid = () => {
      const { grid, selectedLetters } = this.state;

   //  return grid.map((row, rowIndex) => (
   //    <div key={rowIndex} className="grid-row">
   //      {row.map((col, colIndex) => (
   //        <div
   //          key={colIndex}
   //          className={`grid-cell ${selectedLetters.some((coord) => coord.row === rowIndex && coord.col === colIndex) ? 'selected' : ''}`}
   //          onClick={() => this.handleClick(rowIndex, colIndex)}
   //        >
   //          {col}
   //        </div>
   //      ))}
   //    </div>
   //  ));
      return (
         <div className="grid-row">
            {grid.map((col, colIndex) => (
               <div
               key={colIndex}
               className={`grid-cell ${selectedLetters.some((coord) => coord.col === colIndex) ? 'selected' : ''}`}
               onClick={() => this.handleClick(colIndex)}
               >
               {col}
               </div>
            ))}
         </div>
      )
   };

   render() {
      return (
         <div className="word-search-game">
            <div>
               <h5>{this.state.question}</h5>
               <div className="grid-container">{this.renderGrid()}</div>
               <h5 className='answer-section'>{this.state.selectedWord}</h5>
               {
                  this.state.isAnswer && (
                     this.state.isCorrect ? (
                        <h3 className='correct-answer-sorting'>Correct!</h3>
                        ):(
                        <h3 className='wrong-answer-sorting'>Wrong!</h3>
                     )
                  )
               }
               {
                  this.state.selectedWord.length == this.state.grid.length && (
                     <button className='check-answer-sorting' onClick={this.checkWord}>check</button>
                  )
               }
            </div>
         </div>
      );
   }
}

export default SearchWordGame;



// WEBPACK FOOTER //
// ./src/components/GameQuiz/SearchWordGame.js